import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function Sociologija() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Sociologija" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Sociologija</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Sociologija
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>

              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta Sociologija je pružiti studentima uvid u
                osnovne sociološke probleme kako bi razvili znanja o aspektima
                društvenih fenomena. U tom smislu sadržaj predmeta uveliko
                obuhvata teme od profesionalnog interesa pravne struke.
                Izučavajući društvo i odnose u njemu, a naročito one koji su
                važni za razumijevanje prava poput društva, moći, vlasti,
                društvene nejednakosti, siromaštva, nacije, rasizma,
                diskriminacije, korupcije itd., studentima prava će omogućiti
                bolje razumijevanje uloge prava i pravnog sistema u modernim
                društvima.
              </p>

              <h3>Ishod predmeta</h3>
              <p>
                Nakon što student položi ovaj ispit, biće u mogućnosti da:
                definiše i objasni osnovne sociološke pojmove; objasni i
                kritički analizira najznačajnije sociološke teorije; objasni na
                koji način su pojedinac i društvo povezani i uticaj društva na
                ponašanje pojedinaca; tumače društvene promjene; primjene
                stečena znanja u cilju objašnjavanja različitih društvenih
                fenomena; definišu predmet i osnovne probleme sociologije prava.
              </p>

              <h3>Sadržaj predmeta</h3>
              <p>
                Pojam sociologije, sociološke metode i načini sociološkog
                istraživanja, Pojedinac i društvo, ličnost, civilizacija,
                Osnovne društvene grupe, vođenje i upravljanje, komunikacija
                unutar grupe i komunikacije među društvenim grupama, masovne
                komunikacije, Položaj, uloga, status u društvu, društvena
                regulacija, tipologija društvenih uloga, Društvena regulacija:
                vrijednosti, norme i običaji, obredi i simboli, pravo i
                regulacija, Funkcionalizam, pravila funkcionalne analize, uzorci
                i uzročnosti, struktuta i strukturalizam, sistemi, modeli,
                teorije, Tradicionalna društva i moderno društvo, opšta
                obilježja pojedinih tipova društvenih zajednica, legitimitet i
                legalitet, post-industrijsko društvo, Porodica, sistemi
                srodstva, zajednice, Ekonomska i društvena razmjena, klijentela,
                mreže i mrežne strukture u savremenom društvu, organizacija i
                strategije, Klase i društvena slojevitost, nejednakost i izvori
                nejednakosti, marksizam o nejednakosti, Maks Veber društvena
                slojevitost, društvena pokretljivost, moć elite i klase, Nacija,
                društvo i država, tipovi država, otvoreno i zatvoreno društvo,
                Ljudsko društvo kao sistem – organizacija i reprodukcija,
                originalnost ljudskog društva, Društvene promjene, teorija
                društvenih promjena, sukobi, inovacije, rutina i inovacija,
                odluke, teorija promjene, pravo i vrijeme, evoluciona paradigma,
                Mit i ideologija, religija.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja i vježbe, seminarski rad, konsultacije, kolokvijumi,
                završni ispit. Interaktivna nastava koja obuhvata uvodno
                izlaganje od strane predavača i učešće studenta u diskusiji;
                Predavanja i vježbe praćena su odgovarajućim posebno izrađenim
                prezentacijama.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P</td>
                    <td>
                      Pojam sociologije, sociološke metode i načini sociološkog
                      istraživanja
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P</td>
                    <td>Pojedinac i društvo, ličnost, civilizacija</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P</td>
                    <td>
                      Osnovne društvene grupe, vođenje i upravljanje,
                      komunikacija unutar grupe i komunikacije među društvenim
                      grupama, masovne komunikacije
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P</td>
                    <td>
                      Položaj, uloga, status u društvu, društvena regulacija,
                      tipologija društvenih uloga
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P</td>
                    <td>
                      Društvena regulacija: vrijednosti, norme i običaji, obredi
                      i simboli, pravo i regulacija
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P</td>
                    <td>
                      Funkcionalizam, pravila funkcionalne analize, uzorci i
                      uzročnosti, struktuta i strukturalizam, sistemi, modeli,
                      teorije
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P</td>
                    <td>
                      Tradicionalna društva i moderno društvo, opšta obilježja
                      pojedinih tipova društvenih zajednica, legitimitet i
                      legalitet, post-industrijsko društvo
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P</td>
                    <td>Porodica, sistemi srodstva, zajednice</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P</td>
                    <td>
                      Ekonomska i društvena razmjena, klijentela, mreže i mrežne
                      strukture u savremenom društvu, organizacija i strategije
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P</td>
                    <td>
                      Klase i društvena slojevitost, nejednakost i izvori
                      nejednakosti, marksizam o nejednakosti, Maks Veber
                      društvena slojevitost, društvena pokretljivost, moć elite
                      i klase, Nacija, društvo i država, tipovi država, otvoreno
                      i zatvoreno društvo
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>2P</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P</td>
                    <td>
                      Ljudsko društvo kao sistem – organizacija i reprodukcija,
                      originalnost ljudskog društva
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P</td>
                    <td>
                      Društvene promjene, teorija društvenih promjena, sukobi,
                      inovacije, rutina i inovacija, odluke, teorija promjene,
                      pravo i vrijeme, evoluciona paradigma
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P</td>
                    <td>Mit i ideologija, religija</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 2 č / 130h</td>
                            <td>Ukupno: 40 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 130h</td>
                            <td>Nastava + završni ispit: 30 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe:</td>
                            <td>Priprema i ovjera semestra: 3 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 7 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Sociologija;
